import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {I18nModule, UrlModule} from '@spartacus/core';
import {ProductTileComponent} from './product-tile.component';
import {GenericLinkModule, MediaModule} from '@spartacus/storefront';
import {LimitedTextModule} from '../limited-text/limited-text.module';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [
    ProductTileComponent
  ],
  imports: [
    CommonModule,
    MediaModule,
    I18nModule,
    LimitedTextModule,
    RouterModule,
    UrlModule,
    GenericLinkModule
  ],
  exports: [
    ProductTileComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ]
})
export class ProductTileModule {
}
